          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
    <!-- <v-card class="transparent"> -->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Contact_Us.jpeg"
            >
            </v-parallax>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                      <v-layout row wrap class="justify-center mx-3">
                        <v-card class="my-3" width="100%" outlined shaped>
                          <v-card color="#cd3231" width="100%" elevation="4">
                          <v-card-title class="grey darken-3"> 
                            <h2 class="mx-1 my-3 white--text" >Contact Details</h2>
                          </v-card-title>
                          </v-card>
                            <v-layout row wrap class="justify-center mx-3" >
                              <v-card shaped class="my-3" color="rgb(70,68,68)" width="100%"  elevation="8" ripple>
                                <v-card-title> 
                                  <h3 class="white--text mx-1 my-3" >Phone Us</h3> 
                                </v-card-title>
                                <v-card-subtitle> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"
                                  href="tel:+27823183953"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-deskphone</v-icon>
                                    </v-avatar>
                                  082 318 3953
                                  </v-chip> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"
                                  href="tel:+27636072800"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-deskphone</v-icon>
                                    </v-avatar>
                                  063 607 2800
                                  </v-chip> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"
                                  href="tel:+27123321901"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-deskphone</v-icon>
                                    </v-avatar>
                                  012 332 1901
                                  </v-chip>
                                </v-card-subtitle>                  
                              </v-card>
                          </v-layout>
                            <v-layout row wrap class="justify-center mx-3" >
                              <v-card shaped class="my-3" color="rgb(70,68,68)" width="100%"  elevation="8" ripple>
                                <v-card-title> 
                                  <h3 class="white--text mx-1 my-3" >Email Us</h3> 
                                </v-card-title>
                                <v-card-subtitle> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"
                                  href="mailto:admin@tribunessa"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-email</v-icon>
                                    </v-avatar>
                                  admin@tribunessa
                                  </v-chip> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"
                                  href="mailto:legal@tribunessa.co.za"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-email</v-icon>
                                    </v-avatar>
                                  legal@tribunessa.co.za
                                  </v-chip>
                                </v-card-subtitle>                  
                              </v-card>
                          </v-layout>
                            <v-layout row wrap class="justify-center mx-3" >
                              <v-card shaped class="my-3" color="rgb(70,68,68)" width="100%"  elevation="8" ripple>
                                <v-card-title> 
                                  <h3 class="white--text mx-1 my-3" >Head Office</h3> 
                                </v-card-title>
                                <v-card-subtitle> 
                                  <v-chip outlined
                                  class="ma-2"
                                  color="pop"
                                  text-color="pop"                                  
                                  >
                                    <v-avatar left>
                                      <v-icon color="white --text">mdi-map-marker</v-icon>
                                    </v-avatar>
                                  Gauteng, Pretoria, Annlin
                                  </v-chip>
                                </v-card-subtitle>                  
                              </v-card>
                          </v-layout>                         
                        </v-card>
                      </v-layout>
                </v-flex>
                </v-layout>            
            </v-card>
            <!-- </div>-->
            
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {

    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        